import { render, staticRenderFns } from "./CheckApprovalView.vue?vue&type=template&id=518efdb0"
import script from "./CheckApprovalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckApprovalView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports